function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 21.515,
  cy: 21.515,
  r: 21.515,
  fill: "#2f75ec"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Mail",
  d: "M2.666,12.137A2.792,2.792,0,0,1,1.1,11.654l.545-.591,5.073-5.5,1.913,1.3.09.032h.03a.379.379,0,0,0,.048,0,.365.365,0,0,0,.047,0,.322.322,0,0,0,.094,0h.03l.064-.032,1.928-1.31,5.047,5.494.533.579a2.934,2.934,0,0,1-1.648.508H2.779ZM.56,11.094h0A3.27,3.27,0,0,1,0,9.216L0,2.909A3.379,3.379,0,0,1,.412,1.266l.638.436,4.994,3.41L1.1,10.511l-.536.583Zm16.547,0h0l-.54-.591L11.621,5.1,16.611,1.7l.643-.432a3.225,3.225,0,0,1,.4,1.651v6.3a3.091,3.091,0,0,1-.544,1.873ZM8.794,6.029h0L6.9,4.739a.383.383,0,0,0-.136-.087L1.573,1.119.889.654A2.7,2.7,0,0,1,2.641,0c.053,0,.1,0,.138,0H14.928a2.891,2.891,0,0,1,1.816.652l-.688.469L8.794,6.029Z",
  transform: "translate(12.688 15.447)",
  fill: "#fff"
});

function SvgEMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "E-mail",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.03,
    height: 43.03,
    viewBox: "0 0 43.03 43.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEMail);
export default __webpack_public_path__ + "static/media/E-mail.e11eb8aa.svg";
export { ForwardRef as ReactComponent };